var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path501",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41433",
    "data-name": "Group 41433",
    transform: "translate(18958 7383)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15703",
    "data-name": "Rectangle 15703",
    width: 16,
    height: 16,
    transform: "translate(-18958 -7383)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g495",
    transform: "translate(-18957 -6699.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g497",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g499",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g505",
    transform: "translate(0.547 0.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path507",
    d: "M-102.085-513.687v.51a1.641,1.641,0,0,0,1.641,1.641h7.488a1.641,1.641,0,0,0,1.641-1.641v-7.474a1.641,1.641,0,0,0-1.641-1.641h-.5m-10.769,6.964V-522.8a1.641,1.641,0,0,1,1.641-1.641h7.488a1.641,1.641,0,0,1,1.641,1.641v7.474a1.641,1.641,0,0,1-1.641,1.641h-7.488A1.641,1.641,0,0,1-104.222-515.328Z",
    transform: "translate(104.222 524.443)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.45b854b15325c89bfb26c9d09b6787cb.svg";
export { ForwardRef as ReactComponent };